import React from 'react';
import PropTypes from 'prop-types';

import { ChapterPage } from '../../partials';

export const DisplayFlexChapter = ({ name }) => (
  <ChapterPage title={name}>
    <p>
      The foundation of flexbox CSS is the <code>display: flex</code> property.
      Just add this property to an element, and you&rsquo;re using flexbox.
      It&rsquo;s that easy!
    </p>

    <p>
      But what exactly is this property doing? By default, it specifies that the
      element should now lay out its children along what&rsquo;s called its
      &ldquo;main axis&rdquo;, which is the horizontal axis by default.
    </p>

    <p>
      This section will introduce you to how this property works and how you can
      use it to build UI components
    </p>
  </ChapterPage>
);

DisplayFlexChapter.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/chapters/DisplayFlexChapter.js